<template>
  <div class="d-flex justify-content-between">
    <div class="d-flex blog__media">
      <a :href="link" class="blog__media-item">
        <img src="/assets/images/icons/comments.svg" alt="" />
        <span v-text="comments_count"></span>
      </a>
      <div class="blog__media-item" :class="{ 'liked': follow }" @click.prevent="handleLikeArticle">
        <img :src="isPostLiked" width="21" height="19" :key="isPostLiked" alt="" />
      </div>
      <div class="blog__media-item" data-toggle="modal" data-target="#socilaShareModal" @click.prevent="handleSharedLink">
        <img src="/assets/images/icons/share.svg" alt="" />
      </div>
    </div>
    <a :href="link">Читать</a>
  </div>
</template>

<script>

import { likeArticle } from './api'
import { eventHub } from './eventHub'


export default {
    name: "ArticleMediaNav",

    props: {
      post_id: { type: Number, required: true },
      comments_count: { type: Number, required: true, default: 0 },
      follow: { type: Boolean, required: true, default: false },
      link: { type: String, required: true, default: '/' }
    },

    computed: {

      isPostLiked(){
        let { follow } = this

        return follow ? '/assets/images/icons/likes-red.svg' : '/assets/images/icons/likes.svg'  
      }

    },

    methods: {

      handleSharedLink(){
        window.blogSharedLink = this.link
      },

      async handleLikeArticle(){

        try{

          let { post_id } = this
          let follow = this.follow ? 0 : 1
          let params = { post_id, follow }

          let { data: { success = false } } = await likeArticle({ params })

          if( success ){

            eventHub.$emit( 
              'update:postLiked',
              { post_id, follow: Boolean(follow) }
            )

          }


        } catch( e ){

          console.log(e);

        }

      }

    }

}

</script>
